<template>
  <div class="hm-switch-tabs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HMSwitchTabs',
  props: {
    selected: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(tabName) {
      this.$emit('update:selected', tabName);
      this.$emit('change', this.selected);
    },
  },
  watch: {
    selected(selected) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selected;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-switch-tabs {
  display: inline-flex;
  border: 1px solid $medium-gray;
  border-radius: 6px;
  height: 42px;
  padding: 2px;
}
</style>
